import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { SelectContainer } from '@/components/inputs/SelectContainer'
import { ReopenJobAsAdminDialog } from '@/features/jobs/details/components/ReopenJobAsAdminDialog'
import {
  type ReopenJobAsAdminDialogViewModel,
  reopenReasons,
} from './ReopenJobAsAdminDialogViewModel'

export interface ReopenJobAsAdminDialogContainerProps {
  vm: ReopenJobAsAdminDialogViewModel
}

export const ReopenJobAsAdminDialogContainer = observer(
  function ReopenJobAsAdminDialogContainer({
    vm,
  }: ReopenJobAsAdminDialogContainerProps) {
    return (
      <ReopenJobAsAdminDialog
        showing={vm.modal.showing}
        reasonField={
          <SelectContainer
            model={vm}
            field="reasonOption"
            name="reasonOption"
            items={reopenReasons.map((r) => [r])}
            placeholder="Select a reason"
            error={vm.validation.getError('reasonOption')}
            data-test="reopen-job-as-admin-reason-select"
          />
        }
        otherReasonField={
          vm.isOtherReason && (
            <TextAreaContainer
              model={vm}
              field="otherReason"
              name="otherReason"
              placeholder="Describe the reason"
              error={vm.validation.getError('otherReason')}
              data-test="reopen-job-as-admin-reason-input"
              rows={4}
            />
          )
        }
        reasonHelpText={vm.reasonHelpText}
        isReopenPending={vm.reopenJobAsAdmin.pending}
        isReopenRejected={vm.reopenJobAsAdmin.rejected}
        isReopenDisabled={vm.isReopenDisabled}
        reopenError={vm.reopenJobAsAdmin.error}
        onClose={vm.modal.close}
        onReopen={vm.reopenJobAsAdmin}
        submitButtonTestId="reopen-job-as-admin-submit-button"
      />
    )
  },
)
